module.exports = __webpack_public_path__ + "media/images/built-b80b2cc33010496ddb33423cf7f78949.svg";